type Props = {
  size?: number;
};

export function NerdWalletBadge({ size = 24 }: Props) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.0601 8.03007V0.541353C16.0601 0.270676 16.2406 0 16.5113 0H23.5489C23.8195 0 24 0.270676 24 0.541353V8.03007V15.9699L16.0601 8.03007ZM23.5489 24H16.3308C16.2406 24 16.1504 24 16.0601 23.9098L24 15.9699V23.4586C24 23.7293 23.8195 24 23.5489 24ZM0.180451 23.8195L8.03007 15.9699V0.0902351H7.93984L0 8.03008V23.4586C0 23.6391 0.0902255 23.7293 0.180451 23.8195Z"
        fill="#8DC63F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.541353 0C0.270676 0 0 0.270676 0 0.541353V8.03007L7.93984 0.0902255C7.84962 0 7.75939 0 7.66917 0H0.541353ZM16.0601 23.9098C16.015 23.9098 15.9699 23.8872 15.9248 23.8647C15.8797 23.8421 15.8346 23.8195 15.7895 23.8195L8.03008 15.9699V0.0902351C8.1203 0.0902351 8.21053 0.180461 8.21053 0.180461L16.0601 8.03008V23.9098ZM7.48872 24H0.541353C0.360902 24 0.270676 23.9098 0.180451 23.8195L8.03007 15.9699V23.4586C8.03007 23.7293 7.75939 24 7.48872 24Z"
        fill="#00AE4D"
      />
      <path d="M16.0601 23.91V8.03027L23.9999 15.9701L16.0601 23.91Z" fill="#00682C" />
    </svg>
  );
}
